import { Text } from "@meditect/medibase-components";

export const DeliveriesMissingMultiplierCoefficientError = (): React.ReactElement => {
  return (
    <Text>
      Cette réception ne peut pas être validée : renseignez le coefficient multiplicateur des produits qui n'en ont pas
      encore.
    </Text>
  );
};
